import { render } from "./FlyTo.vue?vue&type=template&id=3504b326&scoped=true&bindings={\"map\":\"data\",\"marker\":\"data\",\"waterstations\":\"data\",\"activeChapterName\":\"data\",\"lastWaterstation\":\"data\",\"chapters\":\"data\",\"setActiveChapter\":\"options\",\"getContentful\":\"options\",\"checkSlide\":\"options\"}"
import script from "./FlyTo.vue?vue&type=script&lang=js"
export * from "./FlyTo.vue?vue&type=script&lang=js"

import "./FlyTo.vue?vue&type=style&index=0&id=3504b326&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3504b326"

export default script